export default __webpack_public_path__ + "static/media/arrow_blue_down.415aa633.svg";